import { CheckBoxState } from "../../models/client/checkbox-state";
import { OptionMap } from "./../../models/client/option-map";

export function mapToInitialCheckGroupState(
  optionMap: OptionMap
): CheckBoxState[] {
  return Object.keys(optionMap).map((key) => ({
    key,
    label: optionMap[key].label,
    color: optionMap[key].color,
    checked: true,
  }));
}

export function handleCheckGroupChange(
  checkGroupState: CheckBoxState[],
  { key, checked }: { key: string; checked: boolean }
): CheckBoxState[] {
  return checkGroupState.map((state) => {
    if (state.key === key) {
      return {
        ...state,
        checked,
      };
    }
    return state;
  });
}

export function checkBoxStateToArr(checkGroupState: CheckBoxState[]): string[] {
  return checkGroupState.reduce((arr, checkState) => {
    if (checkState.checked) {
      arr.push(checkState.key);
    }
    return arr;
  }, [] as string[]);
}
